export enum OTPVerificationFailedCase {
  INVALID_OTP = 'INVALID_OTP',
  OTP_EXPIRED = 'OTP_EXPIRED',
  OTP_VERIFICATION_FAILED = 'OTP_VERIFICATION_FAILED'
}

export interface OTPVerificationState {
  isOTPVerified: boolean
  isOTPVerificationLoading: boolean
  isOTPVerificationLimitExceeded: boolean
  OTPVerificationFailedCase: OTPVerificationFailedCase | null
}

export interface OTPVerificationHandlers {
  handleOTPVerification: (otp: string) => void
  handleResendOTP: () => void
}
